module.exports = __webpack_public_path__ + "static/media/animal-lion.2cb709fe.png";